import React, { useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface Image {
  url: string;
  alt: string;
}

interface SlidingGalleryProps {
  images: Image[];
  currentSlide: number;
  onSlideChange: (index: number) => void;
}

const SlidingGallery: React.FC<SlidingGalleryProps> = ({ images, currentSlide, onSlideChange }) => {
  const sliderRef = useRef<Slider>(null);

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(currentSlide);
    }
  }, [currentSlide]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    beforeChange: (_oldIndex: number, newIndex: number) => {
      onSlideChange(newIndex);
    },
  };

  return (
    <div className="slider-wrapper">
      <Slider ref={sliderRef} {...settings}>
        {images.map((image, idx) => (
          <div key={idx}>
            <img
              src={image.url}
              alt={image.alt}
              style={{
                width: "600px",
                height: "500px",           // Fixed height (half the previous height)
                objectFit: "contain",       // Show full image without cropping
                display: "block",
                backgroundColor: "transparent" // This is the key

              }}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default SlidingGallery;
